import React, { Fragment, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterOperations } from '../../redux/filter';
import { configOperations } from '../../redux/config';
import { userOperations } from '../../redux/user';
import { incidentsOperations } from '../../redux/incidentList';
import { history } from '../../index';
import originFields from '../../defaults/PointOfOriginFields.json'
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import FiltersContainer from './filter/FiltersContainer';
import IncidentList from './list/IncidentList';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import CustomFilterList from '../arcgisFilter/CustomFilterList';
import { setOriginLayerDefinitionExpression, setCustomFilterDefinitionExpression } from '../esri/mapHub';
import './index.css';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

class Main extends Component {

  constructor (props) {
    super(props);

    this.state =
    {
      tabValue: (this.props.filter.isBasicFilterActive) ? 0 : 1,
      isDownloading: false
    }
  }

  handleTabChange = (event, newValue) =>
  {
    this.setState({
      tabValue: newValue
    });

    if (newValue === 0)
    {
        this.props.setFilterLoading(true);

        setOriginLayerDefinitionExpression(this.props.filter).then( response => {
          debugger;
          this.props.setQueriedIncidentsTotal(response.total);
          this.props.setIncidents(response.features);
          this.props.setVisibleIncidents(response.features);
          this.props.setDisplayedIncidentsCount(response.features.length);
          this.props.setFilterLoading(false);
        });
        this.props.setBasicFilterActive(true);
    }
    else
    {
      if (this.props.user.activeCustomFilter !== null)
      {
          setCustomFilterDefinitionExpression(this.props.user.activeCustomFilter).then( response => {
            this.props.setQueriedIncidentsTotal(response.total);
            this.props.setIncidents(response.features);
            this.props.setVisibleIncidents(response.features);
            this.props.setDisplayedIncidentsCount(response.features.length);
            this.props.setFilterLoading(false);
          });
          this.props.setBasicFilterActive(false);
      }
    }
  };

  incidentSelected = (selectedIncident, isQuarantined) => {
      const forId = selectedIncident.attributes[originFields.forId];
        history.push("/incidents/"+forId);
    }
    
  getShareUrl = () => {
    const baseURL = window.location.origin + window.location.pathname;
    const filter = Object.assign({},this.props.filter, {loading: true, visible: true});
    let map = Object.assign({},this.props.map);

    delete map.loaded;

    let searchParams = new URLSearchParams();
    searchParams.append('map', JSON.stringify(map));
    searchParams.append('filter', JSON.stringify(filter));
    return baseURL + '?' + searchParams.toString();
  }

  toggleFilterCollapse = () => {
    this.props.setFilterVisible(!this.props.filter.visible)
  }

  requeryFeatureLayerOnSort = () => 
  {
    if (this.state.tabValue === 0)
    {
        this.props.setFilterLoading(true);

        setOriginLayerDefinitionExpression(this.props.filter).then( response => {
          debugger;
          this.props.setQueriedIncidentsTotal(response.total);
          this.props.setIncidents(response.features);
          this.props.setVisibleIncidents(response.features);
          this.props.setDisplayedIncidentsCount(response.features.length);
          this.props.setFilterLoading(false);
        });
        this.props.setBasicFilterActive(true);
    }
    else
    {
      if (this.props.user.activeCustomFilter !== null)
      {
          setCustomFilterDefinitionExpression(this.props.user.activeCustomFilter).then( response => {
            this.props.setQueriedIncidentsTotal(response.total);
            this.props.setIncidents(response.features);
            this.props.setVisibleIncidents(response.features);
            this.props.setDisplayedIncidentsCount(response.features.length);
            this.props.setFilterLoading(false);
          });
          this.props.setBasicFilterActive(false);
      }
    }
  }

  resetFilters = () =>
  {
    this.props.filter.resetFilters();
  }

  toggleIncidentListCollapse = () => {
    this.props.setIncidentListVisible(!this.props.incidentList.visible)
  }

  sortChange = (sortField) => {
    this.props.setSortField(sortField);
    this.requeryFeatureLayerOnSort();
  }

  toggleSortDesc = () => {
    this.props.setSortDesc(!this.props.appConfig.sortDesc);
    this.requeryFeatureLayerOnSort();
  }

  render() {
    const incidents = this.props.incidentList.visibleIncidents;
    //const totalIncidentsCount = incidents.length;

    const shareURL = this.getShareUrl();
    return (
      <Fragment>
       <Paper square>
       <Tabs value={this.state.tabValue} onChange={this.handleTabChange} aria-label="simple tabs example">
         <Tab label="Basic" {...a11yProps(0)}  />
         <Tab label="Custom" {...a11yProps(1)} />
       </Tabs>
         <TabPanel value={this.state.tabValue} index={0}>
         <div className="filter-container-class">
         <FiltersContainer
           filter={this.props.filter}
           resetFilters={this.resetFilters.bind(this)}
           filterVisible={this.props.filter.visible} />
          </div>
         </TabPanel>
         <TabPanel value={this.state.tabValue} index={1}>
           <div className="filter-container-class">
           <CustomFilterList/>
           </div>
         </TabPanel>
    </Paper>
        <IncidentList
          incidents={incidents}
          sortField={this.props.appConfig.sortField}
          sortDesc={this.props.appConfig.sortDesc}
          onIncidentSelected={this.incidentSelected}
          toggleIncidentListCollapse={this.toggleIncidentListCollapse.bind(this)}
          onSortChange={this.sortChange}
          onToggleSortDesc={this.toggleSortDesc}
          isDownloading={this.state.isDownloading}
          shareURL={shareURL}
          incidentListVisible={this.props.incidentList.visible}
          />
        </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  appConfig: state.config,
  filter: state.filter,
  user: state.user,
  incidentList: state.incidentList
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...configOperations,
    ...filterOperations,
    ...userOperations,
    ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
